import PropTypes from 'prop-types';

export const TaxRatePropTypes = PropTypes.shape({
  periodName: PropTypes.string,
  countryTaxType: PropTypes.string,
  enabledFlag: PropTypes.string,
  description: PropTypes.string,
  taxRate: PropTypes.string,
  defTaxRate: PropTypes.string,
  plAccount: PropTypes.string,
  bsAccount: PropTypes.string,
  countryCode: PropTypes.string,
});

export const TaxRatesPropTypes = PropTypes.arrayOf(TaxRatePropTypes).isRequired;
